import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, Text as FluentText } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const style = mergeStyles({
  lineHeight: 19,
});

export const Text = ({ text, ...rest }) => {
  const i18n = useContext(I18nContext);
  return <FluentText className={style} {...rest}>{i18n.getString(text)}</FluentText>;
};

Text.propTypes = {
  text: PropTypes.string.isRequired,
};
